/* ==========================================================
   CARROSSEL DOS CARDS
========================================================== */

document.addEventListener("DOMContentLoaded", function () {

  const container = document.querySelector(".misc-product-options__track");
  const cards = [...document.querySelectorAll(".misc-option-card")];

  const left = document.querySelector(".misc-product-options__arrow--prev");
  const right = document.querySelector(".misc-product-options__arrow--next");

  if (!container || !cards.length) return;

  let currentIndex = 0;

  // Centraliza o card selecionado
  function scrollToCard(index) {

    currentIndex = Math.max(
      0,
      Math.min(index, cards.length - 1)
    );

    const card = cards[currentIndex];

    const leftPosition =
      card.offsetLeft -
      (container.clientWidth / 2) +
      (card.offsetWidth / 2);

    container.scrollTo({
      left: leftPosition,
      behavior: "smooth"
    });

  }

  // Descobre qual card está mais próximo do centro
  function updateCurrentIndex() {

    const center =
      container.scrollLeft +
      container.clientWidth / 2;

    let closest = 0;
    let distance = Infinity;

    cards.forEach((card, index) => {

      const cardCenter =
        card.offsetLeft +
        card.offsetWidth / 2;

      const diff = Math.abs(center - cardCenter);

      if (diff < distance) {

        distance = diff;
        closest = index;

      }

    });

    currentIndex = closest;

  }

  function updateArrows() {

    updateCurrentIndex();

    left?.classList.toggle(
      "is-visible",
      currentIndex > 0
    );

    right?.classList.toggle(
      "is-visible",
      currentIndex < cards.length - 1
    );

  }

  // Próximo
  right?.addEventListener("click", function () {

    scrollToCard(currentIndex + 1);

  });

  // Anterior
  left?.addEventListener("click", function () {

    scrollToCard(currentIndex - 1);

  });

  container.addEventListener("scroll", function () {

    requestAnimationFrame(updateArrows);

  });

  window.addEventListener("resize", function () {

    scrollToCard(currentIndex);

  });

  scrollToCard(0);

  setTimeout(updateArrows, 100);

});

/* ==========================================================
   DRAWER TABELA DE MEDIDAS
========================================================== */

document.addEventListener("DOMContentLoaded", function () {

  const drawer = document.querySelector(".tm-drawer");
  const overlay = document.querySelector(".tm-drawer-overlay");
  const close = document.querySelector(".tm-drawer-close");

  if (!drawer || !overlay) return;

  // Move para o body
  document.body.append(drawer, overlay);

  function openDrawer() {

    document.body.classList.add("tm-drawer-open");

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

  }

  function closeDrawer() {

    document.body.classList.remove("tm-drawer-open");

    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";

  }

  // Abrir drawer
  document.addEventListener("click", function (e) {

    const trigger = e.target.closest("[data-open-size-chart]");

    if (!trigger) return;

    e.preventDefault();

    openDrawer();

  });

  // Fechar pelo X
  close?.addEventListener("click", closeDrawer);

  // Fechar clicando fora
  overlay.addEventListener("click", closeDrawer);

  // ESC
  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {
      closeDrawer();
    }

  });

});